"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.triggerAsyncEvent = exports.loadEditServices = exports.default = void 0;
var _ServiceRegistry = _interopRequireDefault(require("./ServiceRegistry"));
var _ConflictingToolsService = _interopRequireDefault(require("../service/ConflictingToolsService"));
var _ToolsBoardService = _interopRequireDefault(require("../verbs/service/ToolsBoardService"));
var _DropinService = _interopRequireDefault(require("../verbs/service/DropinService"));
var _EditHandlerService = _interopRequireDefault(require("../verbs/service/EditHandlerService"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2022 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

const triggerEvent = (eventTyoe, callbackType) => {
  const callbackService = _ServiceRegistry.default.getService("CallbackService");
  if (callbackService.hasCallback(callbackType)) {
    const callbackFn = callbackService.getCallback(callbackType);
    callbackFn(eventTyoe);
  }
};
const loadEditServices = () => {
  _ServiceRegistry.default.register("ConflictingToolsService", new _ConflictingToolsService.default());
  _ServiceRegistry.default.register("ToolsBoardService", new _ToolsBoardService.default());
  _ServiceRegistry.default.register("DropinService", new _DropinService.default());
  _ServiceRegistry.default.register("EditHandlerService", new _EditHandlerService.default());
};
exports.loadEditServices = loadEditServices;
const triggerAsyncEvent = (eventType, callbackType) => {
  const callbackService = _ServiceRegistry.default.getService("CallbackService");
  if (callbackService.hasCallback(callbackType)) {
    const callbackFn = callbackService.getCallback(callbackType);
    return callbackFn(eventType);
  }
  return Promise.reject();
};
exports.triggerAsyncEvent = triggerAsyncEvent;
var _default = exports.default = triggerEvent;